﻿( function( doc ) {
	'use strict';

	class DirectoryList {
		constructor() {
			this.providerId = -1;
			this.prvContainer = app.$( '#prv-container' );
			this.prvOptions = app.$( '#prv-options' );
			this.loadOptions();
		}

		loadProviders(val) {

			app.$.fetch( 'api/providersGetForView', {
				body: {
					providerId: val
				}
			} ).then( rsp => {

				if ( rsp.success ) {
					this.prvContainer.innerHTML = rsp.obj; 

				} else {
					console.log( rsp.msg );
				}

			} );
		}

		loadOptions() { 

			app.$.fetch( 'api/providerGetOptions', {
				body: {
					emptyMsg: 'Show All Providers'
				}
			} ).then( rsp => {

				if ( rsp.success ) {
					this.prvOptions.innerHTML = rsp.obj;
					this.loadProviders( -1 );

					this.prvOptions.addEventListener( 'change', () => {
						let val = this.prvOptions.options[this.prvOptions.selectedIndex].value;

						if ( val !== -1 ) {
							this.loadProviders( val );
						} 
					});

				} else {
					console.log( rsp.msg );
				}

			} );
		} 
	} 

	let dl = new DirectoryList();

} )( document );